import Axios from 'axios';

const HTTP_BACK_OFFICE = Axios.create({
  baseURL: `${process.env.BACK_OFFICE_API}`,
  timeout: process.env.TIMEOUT,
  headers: {
    'Access-Control-Allow-Origin': '*',
  },
});

export default HTTP_BACK_OFFICE;



// WEBPACK FOOTER //
// ./src/http.js